import { TableContainer, Table, TableBody } from '@material-ui/core';
import {React, useEffect, clsx, api } from '../../../barrelFiles/basicBarrelFile';
import ProjectsTableRow from './ProjectsTableRow/ProjectsTableRow';
import ProjectsTablePagination from './ProjectsTablePaginationRow';
import EnhancedTableHead from './EnhancedTabledHead';
import { stableSort, stableSort2, getComparator } from './ProjectTableComparators';
import SearchBarRow from './SearchBarRow';

// This component is used to render the table inside home page
const ProjectsTable = (props) => {
  const { data, setUpdateData, updateData, isHome, setDisplayKickedOutMessage } = props;

  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('date');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [searched, setSearched] = React.useState('');
  const [filterStatus, setFilterStatus] = React.useState('Show all');
  const [filterRole, setFilterRole] = React.useState('Show all');
  const [filterShow, setFilterShow] = React.useState('Show all');
  const [filterBy,setFilterBy] = React.useState('date');
  const [init, setInit] = React.useState(false);
  const [response,setResponse] = React.useState(undefined)
  const [pressVisibilityButton, setPressVisibilityButton] = React.useState(false);
  const [ownerId, setOwnerId] = React.useState(-1);
  const [filteredData, setFilteredData ] = React.useState([]); 
  const [hiddenProjects, setHiddenProjects] = React.useState([]);
  const [activeProjects, setActiveProjects] = React.useState([]);
  const [visibilityTable, setVisibilityTable] = React.useState([]);

  const handleRequestSort = (property) => {

    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  useEffect( () => {

    if(init === false || pressVisibilityButton === true){

      api.getUserField('userPreferences')
          .then(resp => {
            setResponse(resp)

            const tempVisibilityTable = [];
            setHiddenProjects(resp.data.hiddenProjects)

            data.forEach( (row) => {
              if (resp.data.hiddenProjects.includes(row._id) === true){
                tempVisibilityTable.push(true);
              }
              else{
                tempVisibilityTable.push(false);
              }
            })
            setVisibilityTable(tempVisibilityTable);

          })
          .catch((err) => {throw err;});  
      setInit(true);
      
      setPressVisibilityButton(false);

  }

  },[init,pressVisibilityButton])

  useEffect( () => {

    const tempActiveProjects = data.filter( project => project.status === 'ACTIVE').map( project => project._id);
    setActiveProjects(tempActiveProjects)
    
  },[data])

  useEffect( () => {

    if(init === false){

      const userLoginName = JSON.parse(localStorage.getItem('user')).login;

      api.getUserWithParam({ name: userLoginName})
      .then((resp) => {
          setOwnerId(resp.data._id);
      })
      .catch((error) => {throw error;});

    }

  },[init])

  useEffect( () => {

    const tempFilteredData = [];
    data
      .filter( (row) => ( filterStatus === 'Show all' || ( filterStatus === 'Show active' && activeProjects.includes(row._id) === true ) || (filterStatus === 'Show suspended' && activeProjects.includes(row._id) === false )  ))
      .filter( (row) => (filterShow === 'Show all' || ( filterShow === 'Show visible' && hiddenProjects.includes(row._id) === false ) || ( filterShow === 'Show non visible' && hiddenProjects.includes(row._id) === true)))
      .filter( (row) => (filterRole === 'Show all' || ( filterRole === 'Show owner' && row.owner === ownerId ) || ( filterRole === 'Show member' && row.owner !== ownerId)))
      .filter((row) => row.name.toLowerCase().includes(searched.toLowerCase()))
      .map(row => tempFilteredData.push(row));

    setFilteredData(tempFilteredData);

  },[searched,filterStatus,filterShow,filterRole,data,updateData,hiddenProjects,activeProjects])

  return (
    <div>
      <SearchBarRow searched={searched} setSearched={setSearched} isHome={isHome} />

      <TableContainer className={clsx('blueBorderStyle')}>
        <Table aria-label="simple table">
          <EnhancedTableHead
            onRequestSort={handleRequestSort}
            setFilterStatus={setFilterStatus}
            setFilterRole={setFilterRole}
            setFilterShow={setFilterShow}
            order={order}
            filterBy={filterBy}
            setFilterBy={setFilterBy}
            response={response}
          />
          <ProjectsTableBody
            data={filteredData}
            order={order}
            orderBy={orderBy}
            page={page}
            rowsPerPage={rowsPerPage}
            updateData={updateData}
            setUpdateData={setUpdateData}
            response={response}
            setPressVisibilityButton={setPressVisibilityButton}
            filterBy={filterBy}
            hiddenProjects={hiddenProjects}
            setHiddenProjects={setHiddenProjects}
            visibilityTable={visibilityTable}
            activeProjects={activeProjects}
            setActiveProjects={setActiveProjects}
            setDisplayKickedOutMessage={setDisplayKickedOutMessage}
          />
        </Table>
      </TableContainer>
      <ProjectsTablePagination
        page={page}
        setPage={setPage}
        data={filteredData}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
    </div>
  );
};



// This component is used to render the main body of home's table with projects.
const ProjectsTableBody = (props) => {
  const {
    data,
    order,
    orderBy,
    page,
    rowsPerPage,
    updateData,
    setUpdateData,
    response,
    setPressVisibilityButton,
    filterBy,
    hiddenProjects,
    setHiddenProjects,
    visibilityTable,
    activeProjects,
    setActiveProjects,
    setDisplayKickedOutMessage
  } = props;

  return (
    <TableBody id='projectsTableBody'>
      { filterBy === 'name' || filterBy === 'date' ?
        stableSort2(data,getComparator(order, orderBy)) 
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => (
            <ProjectsTableRow
              row={row}
              index={index}
              updateData={updateData}
              setUpdateData={setUpdateData}
              key={row._id}
              response={response}
              setPressVisibilityButton={setPressVisibilityButton}
              hiddenProjects={hiddenProjects}
              setHiddenProjects={setHiddenProjects}
              activeProjects={activeProjects}
              setActiveProjects={setActiveProjects}
              setDisplayKickedOutMessage={setDisplayKickedOutMessage}
            />
          ))
    
        : 
        stableSort(data,visibilityTable)
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => (
            <ProjectsTableRow
              row={row}
              index={index}
              updateData={updateData}
              setUpdateData={setUpdateData}
              key={row._id}
              response={response}
              setPressVisibilityButton={setPressVisibilityButton}
              hiddenProjects={hiddenProjects}
              setHiddenProjects={setHiddenProjects}
              activeProjects={activeProjects}
              setActiveProjects={setActiveProjects}
              setDisplayKickedOutMessage={setDisplayKickedOutMessage}
            />
          ))    
        }
    </TableBody>
  );
};

export default ProjectsTable;
